// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__3ORLq","empty":"ModalGraph_empty__3RDqa"};